// Ecosystem Measures PDF Generator - Atelier 3 Activité 4 (bilingue FR/EN)
import jsPDF from "jspdf";
import "jspdf-autotable";

const STRINGS = {
  fr: {
    metaTitle: "Rapport Atelier 3 - Mesures de Sécurité",
    metaSubject: "EBIOS RM - Atelier 3 - Activité 4 - Mesures de Sécurité",
    metaAuthor: "Système EBIOS RM",
    metaCreator: "EBIOS RM Ecosystem Measures Report Generator",
    metaKeywords: "EBIOS RM, Atelier 3, Mesures, Sécurité, Risques",
    defaultAnalysisName: "Analyse EBIOS RM",
    defaultOrg: "Organisation",
    reference: "EBIOSRM_ATELIER3_ACT4",
    locale: "fr-FR",
    status: "Finalisé",
    reportType: "Atelier 3 - Activité 4 - Mesures de Sécurité",
    categories: {
      governance: "GOUVERNANCE",
      protection: "PROTECTION",
      defense: "DÉFENSE",
      resilience: "RÉSILIENCE",
      other: "AUTRE",
    },
    priorities: {
      high: "Haute",
      medium: "Moyenne",
      low: "Basse",
    },
    statuses: {
      planned: "Planifiée",
      "in-progress": "En cours",
      implemented: "Implémentée",
      abandoned: "Abandonnée",
    },
    programLabel: "Programme :",
    programValue: "Analyse des risques – EBIOS RM",
    internal: "Interne",
    documentLabel: "Document :",
    docTypeValue: "Rapport Atelier 3 - Mesures de Sécurité",
    versionLabel: "Version :",
    refLabel: "Réf :",
    reportHeading: "Rapport d'Analyse de Risques:",
    fallbackScope: "Atelier 3",
    ebiosTitle: "EBIOS RM - Atelier 3",
    coverSubtitle: "Activité 4 - Mesures de Sécurité",
    infoProgramLabel: "Programme",
    infoProgramValue: "Atelier 3 - Activité 4 - Mesures de Sécurité",
    infoOrgLabel: "Organisation",
    notSpecified: "Non spécifié",
    classificationLabel: "Classification",
    revisionFreqLabel: "Fréquence de révision",
    revisionFreqValue: "Annuelle / chaque changement majeur",
    statusLabel: "Statut",
    statusValue: "Complété",
    genDateLabel: "Date de génération",
    historyHeaders: [
      "Version",
      "Date",
      "Description, remarques",
      "Auteur",
      "Vérificateur",
      "Approbateur",
    ],
    initialEntry: "Rapport initial Mesures de Sécurité",
    footerMethodo: "Méthodologie EBIOS RM - Atelier 3: Mesures de Sécurité",
    footerConfidential: "Document confidentiel - Usage interne uniquement",
    pageHeader: "Rapport Atelier 3 - Mesures de Sécurité",
    pageHeaderRight: "Mesures de Sécurité",
    pageFooterLeft: "Rapport EBIOS RM",
    pageFooterCenter: "Confidentiel - Usage interne",
    measuresSectionTitle: "MESURES DE SÉCURITÉ",
    noMeasures: "Aucune mesure de sécurité définie.",
    sourceUnknown: "Source inconnue",
    noPaths: "Aucun chemin associé",
    deadlineLabel: "Échéance:",
    effectivenessLabel: "Efficacité:",
    categoryFallback: "Autre",
    priorityFallback: "Moyenne",
    statusFallback: "Non défini",
    measuresHeaders: [
      "Titre",
      "Description",
      "Catégorie",
      "Priorité",
      "Statut",
      "Détails",
      "Chemins d'attaque",
    ],
    riskSectionTitle: "RISQUE RÉSIDUEL PAR PARTIE PRENANTE",
    riskInfoText:
      "Le risque initial est calculé en Activité 1. Le risque résiduel est recalculé après application des mesures de sécurité.",
    noResidualData: "Aucune donnée de risque résiduel disponible.",
    riskHeaders: [
      "Partie Prenante",
      "Risque Initial",
      "Ancienne Zone",
      "Risque Résiduel",
      "Expression du risque résiduel",
      "Nouvelle Zone",
      "Réduction (%)",
    ],
    defaultSaveName: "rapport-mesures-securite.pdf",
  },
  en: {
    metaTitle: "Workshop 3 Report - Security Measures",
    metaSubject: "EBIOS RM - Workshop 3 - Activity 4 - Security Measures",
    metaAuthor: "EBIOS RM System",
    metaCreator: "EBIOS RM Ecosystem Measures Report Generator",
    metaKeywords: "EBIOS RM, Workshop 3, Measures, Security, Risks",
    defaultAnalysisName: "EBIOS RM Analysis",
    defaultOrg: "Organization",
    reference: "EBIOSRM_WORKSHOP3_ACT4",
    locale: "en-GB",
    status: "Finalized",
    reportType: "Workshop 3 - Activity 4 - Security Measures",
    categories: {
      governance: "GOVERNANCE",
      protection: "PROTECTION",
      defense: "DEFENSE",
      resilience: "RESILIENCE",
      other: "OTHER",
    },
    priorities: {
      high: "High",
      medium: "Medium",
      low: "Low",
    },
    statuses: {
      planned: "Planned",
      "in-progress": "In Progress",
      implemented: "Implemented",
      abandoned: "Abandoned",
    },
    programLabel: "Program:",
    programValue: "Risk Analysis – EBIOS RM",
    internal: "Internal",
    documentLabel: "Document:",
    docTypeValue: "Workshop 3 Report - Security Measures",
    versionLabel: "Version:",
    refLabel: "Ref:",
    reportHeading: "Risk Analysis Report:",
    fallbackScope: "Workshop 3",
    ebiosTitle: "EBIOS RM - Workshop 3",
    coverSubtitle: "Activity 4 - Security Measures",
    infoProgramLabel: "Program",
    infoProgramValue: "Workshop 3 - Activity 4 - Security Measures",
    infoOrgLabel: "Organization",
    notSpecified: "Not specified",
    classificationLabel: "Classification",
    revisionFreqLabel: "Revision Frequency",
    revisionFreqValue: "Annual / Every major change",
    statusLabel: "Status",
    statusValue: "Completed",
    genDateLabel: "Generation Date",
    historyHeaders: [
      "Version",
      "Date",
      "Description, notes",
      "Author",
      "Reviewer",
      "Approver",
    ],
    initialEntry: "Initial Security Measures Report",
    footerMethodo: "EBIOS RM Methodology - Workshop 3: Security Measures",
    footerConfidential: "Confidential Document - Internal Use Only",
    pageHeader: "Workshop 3 Report - Security Measures",
    pageHeaderRight: "Security Measures",
    pageFooterLeft: "EBIOS RM Report",
    pageFooterCenter: "Confidential - Internal Use",
    measuresSectionTitle: "SECURITY MEASURES",
    noMeasures: "No security measures defined.",
    sourceUnknown: "Unknown source",
    noPaths: "No associated paths",
    deadlineLabel: "Deadline:",
    effectivenessLabel: "Effectiveness:",
    categoryFallback: "Other",
    priorityFallback: "Medium",
    statusFallback: "Not defined",
    measuresHeaders: [
      "Title",
      "Description",
      "Category",
      "Priority",
      "Status",
      "Details",
      "Attack Paths",
    ],
    riskSectionTitle: "RESIDUAL RISK PER STAKEHOLDER",
    riskInfoText:
      "Initial risk is calculated in Workshop 1. Residual risk is recalculated after applying security measures.",
    noResidualData: "No residual risk data available.",
    riskHeaders: [
      "Stakeholder",
      "Initial Risk",
      "Old Zone",
      "Residual Risk",
      "Residual Risk Expression",
      "New Zone",
      "Reduction (%)",
    ],
    defaultSaveName: "security-measures-report.pdf",
  },
};

class EcosystemMeasuresPdfGenerator {
  constructor(reportData, analysisData = {}, lang = "fr") {
    this.reportData = reportData || {};
    this.analysisData = analysisData || {};
    this.lang = lang;
    this.T = STRINGS[lang] || STRINGS.fr;

    // Initialize jsPDF instance in Portrait mode for the cover page
    this.pdf = new jsPDF("p", "mm", "a4");

    // Set PDF metadata
    this.pdf.setProperties({
      title: this.T.metaTitle,
      subject: this.T.metaSubject,
      author: this.T.metaAuthor,
      creator: this.T.metaCreator,
      keywords: this.T.metaKeywords,
    });

    // Set analysis metadata for cover page
    this.metadata = {
      analysisId: this.analysisData.id || this.reportData.analysisId,
      analysisName:
        this.analysisData.name ||
        this.reportData.analysisName ||
        this.T.defaultAnalysisName,
      companyName:
        this.analysisData.companyName ||
        this.reportData.organizationName ||
        this.T.defaultOrg,
      version: "1.0",
      reference: this.T.reference,
      createdBy: this.analysisData.createdBy || this.T.metaAuthor,
      lastModified: new Date().toLocaleDateString(this.T.locale),
      status: this.T.status,
      reportType: this.T.reportType,
    };

    // Constants for translation/formatting
    this.CATEGORIES = { ...this.T.categories };

    this.PRIORITIES = { ...this.T.priorities };

    this.STATUSES = { ...this.T.statuses };
  }

  /**
   * Generate Atelier 3 Activity 4 cover page
   * Matches layout of Ecosystem Report (Atelier 3 Activity 1)
   */
  generateCoverPage() {
    const pageWidth = this.pdf.internal.pageSize.getWidth();
    const pageHeight = this.pdf.internal.pageSize.getHeight();

    // Clean white background
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.rect(0, 0, pageWidth, pageHeight, "F");

    // Header table - Programme info
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.setDrawColor(0, 0, 0);
    this.pdf.setLineWidth(0.5);
    this.pdf.rect(15, 15, 180, 10, "S");

    this.pdf.setFontSize(9);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.programLabel, 17, 21);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.T.programValue, 45, 21);

    // Internal classification label
    this.pdf.setFillColor(200, 200, 200);
    this.pdf.rect(135, 15, 60, 10, "FD");
    this.pdf.setTextColor(0, 0, 0);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.internal, 155, 21);
    this.pdf.setTextColor(0, 0, 0);

    // Document type
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.rect(15, 25, 180, 8, "S");
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.documentLabel, 17, 30);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.T.docTypeValue, 45, 30);

    // Version and Reference
    this.pdf.rect(15, 33, 90, 8, "S");
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.versionLabel, 17, 38);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.metadata.version || "1.0", 37, 38);

    this.pdf.rect(105, 33, 90, 8, "S");
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.refLabel, 107, 38);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.metadata.reference || this.T.reference, 120, 38);

    // Main title
    this.pdf.setFontSize(18);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.setTextColor(37, 99, 235);
    this.pdf.text(this.T.reportHeading, 105, 65, { align: "center" });

    this.pdf.setFontSize(18);
    const analysisName =
      this.reportData.analysisName ||
      this.metadata.companyName ||
      this.T.fallbackScope;
    const maxTW = this.pdf.internal.pageSize.getWidth() - 30;
    const al = this.pdf.splitTextToSize(analysisName, maxTW);
    al.forEach((line, i) => this.pdf.text(line, 105, 80 + i * 7, { align: 'center' }));
    const extraY = (al.length - 1) * 7;

    // EBIOS RM title
    this.pdf.setFontSize(22);
    this.pdf.setTextColor(37, 99, 235);
    this.pdf.text(this.T.ebiosTitle, 105, 105 + extraY, { align: "center" });

    this.pdf.setFontSize(16);
    this.pdf.text(this.T.coverSubtitle, 105, 115 + extraY, {
      align: "center",
    });
    this.pdf.setTextColor(0, 0, 0);

    // Information table
    const tableStartY = 135 + extraY;
    const rowHeight = 8;

    const tableData = [
      [this.T.infoProgramLabel, this.T.infoProgramValue],
      [this.T.infoOrgLabel, this.metadata.companyName || this.T.notSpecified],
      [this.T.classificationLabel, this.T.internal],
      [this.T.revisionFreqLabel, this.T.revisionFreqValue],
      [this.T.statusLabel, this.T.statusValue],
      [this.T.genDateLabel, new Date().toLocaleDateString(this.T.locale)],
    ];

    tableData.forEach((row, index) => {
      const y = tableStartY + index * rowHeight;

      // Label column (blue background)
      this.pdf.setFillColor(41, 82, 163);
      this.pdf.rect(15, y, 65, rowHeight, "FD");
      this.pdf.setTextColor(255, 255, 255);
      this.pdf.setFontSize(9);
      this.pdf.setFont("helvetica", "bold");
      this.pdf.text(row[0], 17, y + 5.5);

      // Value column (light gray background)
      this.pdf.setFillColor(235, 235, 235);
      this.pdf.rect(80, y, 115, rowHeight, "FD");
      this.pdf.setTextColor(0, 0, 0);
      this.pdf.setFont("helvetica", "normal");

      // Handle long text
      const maxWidth = 110;
      const lines = this.pdf.splitTextToSize(row[1], maxWidth);
      if (lines.length > 1) {
        const truncated =
          row[1].length > 50 ? row[1].substring(0, 47) + "..." : row[1];
        this.pdf.text(truncated, 82, y + 5.5);
      } else {
        this.pdf.text(row[1], 82, y + 5.5);
      }
    });

    // Version history table
    const historyY = 200;
    const headerHeight = 10;
    const dataRowHeight = 15;

    const headers = [...this.T.historyHeaders];
    const colWidths = [18, 22, 70, 30, 20, 20];
    let xPos = 15;

    // Draw header row
    headers.forEach((header, i) => {
      this.pdf.setFillColor(41, 82, 163);
      this.pdf.setDrawColor(0, 0, 0);
      this.pdf.setLineWidth(0.5);
      this.pdf.rect(xPos, historyY, colWidths[i], headerHeight, "FD");

      this.pdf.setTextColor(255, 255, 255);
      this.pdf.setFontSize(7);
      this.pdf.setFont("helvetica", "bold");

      const maxHeaderWidth = colWidths[i] - 3;
      const headerLines = this.pdf.splitTextToSize(header, maxHeaderWidth);
      const startY =
        historyY + headerHeight / 2 - (headerLines.length - 1) * 1.5;

      headerLines.forEach((line, lineIndex) => {
        this.pdf.text(line, xPos + 1.5, startY + lineIndex * 3);
      });

      xPos += colWidths[i];
    });

    // Add data row
    xPos = 15;
    const versionData = [
      this.metadata.version || "1.0",
      new Date().toLocaleDateString(this.T.locale),
      this.T.initialEntry,
      "",
      "",
      "",
    ];

    versionData.forEach((data, i) => {
      this.pdf.setFillColor(245, 245, 245);
      this.pdf.setDrawColor(0, 0, 0);
      this.pdf.setLineWidth(0.5);
      this.pdf.rect(
        xPos,
        historyY + headerHeight,
        colWidths[i],
        dataRowHeight,
        "FD",
      );

      this.pdf.setTextColor(0, 0, 0);
      this.pdf.setFontSize(7);
      this.pdf.setFont("helvetica", "normal");

      if (data) {
        const maxColWidth = colWidths[i] - 3;
        const lines = this.pdf.splitTextToSize(data, maxColWidth);
        const maxLines = Math.floor((dataRowHeight - 2) / 3);
        const displayLines = lines.slice(0, maxLines);

        if (lines.length > maxLines && displayLines.length > 0) {
          let truncatedLine = displayLines[displayLines.length - 1];
          const ellipsisWidth = this.pdf.getTextWidth("...");
          const availableWidth = maxColWidth - ellipsisWidth;

          while (
            this.pdf.getTextWidth(truncatedLine) > availableWidth &&
            truncatedLine.length > 0
          ) {
            truncatedLine = truncatedLine.slice(0, -1);
          }
          displayLines[displayLines.length - 1] = truncatedLine + "...";
        }

        const startY =
          historyY +
          headerHeight +
          dataRowHeight / 2 -
          (displayLines.length - 1) * 1.5;
        displayLines.forEach((line, lineIndex) => {
          this.pdf.text(line, xPos + 1.5, startY + lineIndex * 3);
        });
      }
      xPos += colWidths[i];
    });

    // Footer
    const footerY = pageHeight - 20;
    this.pdf.setFontSize(8);
    this.pdf.setTextColor(107, 114, 128);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.T.footerMethodo, 105, footerY, { align: "center" });
    this.pdf.text(this.T.footerConfidential, 105, footerY + 8, {
      align: "center",
    });
  }

  /**
   * Start new content page with clean background
   * @param {string} orientation - 'p' for portrait, 'l' for landscape
   */
  startNewPage(orientation = "p") {
    this.pdf.addPage("a4", orientation);
    const pageWidth = this.pdf.internal.pageSize.getWidth();
    const pageHeight = this.pdf.internal.pageSize.getHeight();

    // White background
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.rect(0, 0, pageWidth, pageHeight, "F");
  }

  /**
   * Add professional page headers and footers to all pages
   */
  addPageNumbers() {
    const pageCount = this.pdf.internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      this.pdf.setPage(i);
      const pageWidth = this.pdf.internal.pageSize.getWidth();
      const pageHeight = this.pdf.internal.pageSize.getHeight();


      if (i === 1) continue;

      // PAGE HEADER
      const headerY = 15;
      this.pdf.setDrawColor(229, 231, 235);
      this.pdf.setLineWidth(0.5);
      this.pdf.line(20, headerY + 5, pageWidth - 20, headerY + 5);

      this.pdf.setFontSize(8);
      this.pdf.setTextColor(107, 114, 128);
      this.pdf.setFont("helvetica", "normal");
      this.pdf.text(this.T.pageHeader, 20, headerY);

      this.pdf.text(this.T.pageHeaderRight, pageWidth - 20, headerY, {
        align: "right",
      });

      // PAGE FOOTER
      const footerY = pageHeight - 10;
      this.pdf.setDrawColor(229, 231, 235);
      this.pdf.setLineWidth(0.5);
      this.pdf.line(20, footerY - 5, pageWidth - 20, footerY - 5);

      this.pdf.setFontSize(8);
      this.pdf.setTextColor(107, 114, 128);
      this.pdf.setFont("helvetica", "normal");
      this.pdf.text(this.T.pageFooterLeft, 20, footerY);

      const centerText = this.T.pageFooterCenter;
      this.pdf.text(centerText, pageWidth / 2, footerY, { align: "center" });

      this.pdf.text(`Page ${i}`, pageWidth - 20, footerY, { align: "right" });
    }
  }

  /**
   * Generate Measures Table
   */
  generateMeasuresTable() {
    const measures = this.reportData.measures || [];
    let currentY = 30;

    this.pdf.setFontSize(18);
    this.pdf.setTextColor(30, 64, 175);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.measuresSectionTitle, 20, currentY);
    currentY += 15;

    if (measures.length === 0) {
      this.pdf.setFontSize(12);
      this.pdf.setTextColor(100, 100, 100);
      this.pdf.text(this.T.noMeasures, 20, currentY);
      return;
    }

    // Sort measures by category then title
    const sortedMeasures = [...measures].sort((a, b) => {
      const catCompare = (a.category || "").localeCompare(b.category || "");
      if (catCompare !== 0) return catCompare;
      return (a.title || "").localeCompare(b.title || "");
    });

    const tableBody = sortedMeasures.map((measure) => {
      // Format benefits
      const benefitsText =
        measure.benefits && measure.benefits.length > 0
          ? measure.benefits.map((b) => `- ${b.description}`).join("\n")
          : "";

      // Format attack paths
      const pathsText =
        measure.attackPathsDetails && measure.attackPathsDetails.length > 0
          ? measure.attackPathsDetails
              .map(
                (p) =>
                  `[${p.referenceCode}] ${p.sourceRiskName || this.T.sourceUnknown}`,
              )
              .join("\n")
          : this.T.noPaths;

      // Format details (Responsible, Deadline, Effectiveness)
      const details = [];
      if (measure.responsibleParty)
        details.push(`Resp: ${measure.responsibleParty}`);
      if (measure.deadline)
        details.push(
          `${this.T.deadlineLabel} ${new Date(measure.deadline).toLocaleDateString(this.T.locale)}`,
        );

      const eff = [];
      if (Number(measure.dependanceEffectiveness) > 0)
        eff.push(`D-${Number(measure.dependanceEffectiveness).toFixed(1)}`);
      if (Number(measure.penetrationEffectiveness) > 0)
        eff.push(`P-${Number(measure.penetrationEffectiveness).toFixed(1)}`);
      if (Number(measure.maturiteCyberEffectiveness) > 0)
        eff.push(`M+${Number(measure.maturiteCyberEffectiveness).toFixed(1)}`);
      if (Number(measure.confianceEffectiveness) > 0)
        eff.push(`C+${Number(measure.confianceEffectiveness).toFixed(1)}`);

      if (eff.length > 0) details.push(`${this.T.effectivenessLabel} ${eff.join(", ")}`);
      const detailsText = details.join("\n");

      return [
        measure.title || "",
        measure.description || "",
        this.CATEGORIES[measure.category] || measure.category || this.T.categoryFallback,
        this.PRIORITIES[measure.priority] || measure.priority || this.T.priorityFallback,
        this.STATUSES[measure.implementation] ||
          measure.implementation ||
          this.T.statusFallback,
        detailsText,
        pathsText,
      ];
    });

    this.pdf.autoTable({
      startY: currentY,
      head: [[...this.T.measuresHeaders]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [30, 64, 175],
        textColor: [255, 255, 255],
        fontSize: 9,
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
      },
      styles: {
        fontSize: 8,
        cellPadding: 3,
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
        overflow: "linebreak",
        valign: "top",
      },
      columnStyles: {
        0: { cellWidth: 35, fontStyle: "bold" }, // Title
        1: { cellWidth: 60 }, // Description
        2: { cellWidth: 25, halign: "center" }, // Category
        3: { cellWidth: 20, halign: "center" }, // Priority
        4: { cellWidth: 25, halign: "center" }, // Status
        5: { cellWidth: 40 }, // Details
        6: { cellWidth: 70 }, // Attack Paths
      },
      alternateRowStyles: {
        fillColor: [245, 247, 250],
      },
      margin: { top: 20, bottom: 20, left: 10, right: 10 },
    });
  }

  /**
   * Generate Residual Risk Table
   */
  generateResidualRiskTable() {
    const residualRisks = this.reportData.residualRisks || [];
    let currentY = 30;

    this.pdf.setFontSize(18);
    this.pdf.setTextColor(30, 64, 175);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.riskSectionTitle, 20, currentY);
    currentY += 15;

    const infoText = this.T.riskInfoText;
    this.pdf.setFontSize(9);
    this.pdf.setTextColor(100, 100, 100);
    this.pdf.setFont("helvetica", "italic");
    this.pdf.text(infoText, 20, currentY);
    currentY += 10;

    if (residualRisks.length === 0) {
      this.pdf.setFontSize(12);
      this.pdf.text(this.T.noResidualData, 20, currentY);
      return;
    }

    const tableBody = residualRisks.map((r) => [
      r.stakeholderName || "",
      r.initialRisk.toFixed(2),
      r.initialZone || "\u2014",
      r.residualRisk.toFixed(2),
      r.residualRiskExpression || "",
      r.residualZone || "\u2014",
      `-${r.reduction}%`,
    ]);

    this.pdf.autoTable({
      startY: currentY,
      head: [[...this.T.riskHeaders]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [30, 64, 175],
        textColor: [255, 255, 255],
        fontSize: 9,
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
      },
      styles: {
        fontSize: 8,
        cellPadding: 3,
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
        overflow: "linebreak",
        valign: "top",
        halign: "center",
      },
      columnStyles: {
        0: { halign: "left", cellWidth: 60, fontStyle: "bold" },
        1: { cellWidth: 25 },
        2: { cellWidth: 30 },
        3: { cellWidth: 25 },
        4: { cellWidth: 60, halign: "left" },
        5: { cellWidth: 30 },
        6: { cellWidth: 20 },
      },
      alternateRowStyles: {
        fillColor: [245, 247, 250],
      },
      margin: { top: 20, bottom: 20, left: 10, right: 10 },
    });
  }

  /**
   * Generate complete report
   */
  async generateReport() {
    try {
      // Page 1: Cover (Portrait)
      this.generateCoverPage();

      // Page 2: Table (Landscape)
      this.startNewPage("l");
      this.generateMeasuresTable();

      // Page 3: Residual Risk (Landscape)
      this.startNewPage("l");
      this.generateResidualRiskTable();

      // Add common elements
      this.addPageNumbers();

      return this.pdf.output("blob");
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    }
  }

  save(filename = this.T.defaultSaveName) {
    this.pdf.save(filename);
  }
}

export default EcosystemMeasuresPdfGenerator;
